import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

import { useModal } from '../Modal/Modal.types';

import { ModalActionsProps } from './ModalActions.types';

export const ModalActions = ({ side, children }: PropsWithChildren<ModalActionsProps>) => {
  const { leftActionsContainer, rightActionsContainer } = useModal();

  if (!leftActionsContainer || !rightActionsContainer) return null;

  return createPortal(children, side === 'left' ? leftActionsContainer : rightActionsContainer);
};
